/**
 * vendor/isomorphic/packages/isomorphic-core/src/components/cards/metric-card.tsx — drawn by
 * `StatusCard`, the same card every Operations tile renders. Reads the `awaiting_approval` entry of
 * the pipeline promise `OrdersByStatusTile` also reads — one query, two consumers, so the card and
 * the pipeline can never disagree (`008` research R4). The count is the API's, not a filter over rows.
 */
import { PiSealCheckDuotone as Seal } from "react-icons/pi";
import { TileBoundary } from "./TileBoundary";
import { StatusCard, UnreadableStatusCard } from "./StatusCard";
import { formatCount } from "./TrendStatCard";

const icon = <Seal aria-hidden className="size-5" />;

function unreadable(error: unknown) {
  return <UnreadableStatusCard title="Awaiting approval" icon={icon} error={error} fallback="Could not be read — this is not the same as nothing waiting." />;
}

export function AwaitingApprovalCard({ resolve }: { resolve: Promise<Record<string, number | string>> }) {
  return (
    <TileBoundary resolve={resolve} errorFallback={unreadable}>
      {(pipeline) => {
        // The API fills every state, zeros included; a missing key is a contract change, shown as "—".
        const count = pipeline.awaiting_approval === undefined ? "—" : formatCount(pipeline.awaiting_approval);
        return (
          <StatusCard
            title="Awaiting approval"
            icon={icon}
            tone={count === "—" ? "muted" : count === "0" ? "success" : "warning"}
            value={count}
            caption="Orders held for a Sales or Account Manager."
            link={{ to: "/orders?state=awaiting_approval", label: "Open orders awaiting approval" }}
          />
        );
      }}
    </TileBoundary>
  );
}
